import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Contact from "../components/Contact";

const pillars = [
  {
    title: "AI & Innovation",
    description:
      "Leveraging artificial intelligence and smart-building automation to increase asset value and operational efficiency.",
    href: "/ai",
  },
  {
    title: "Renewable Energy",
    description:
      "Feasibility studies and integration of solar, wind, and microgrid solutions for a sustainable future.",
    href: "/renewable-energy",
  },
  {
    title: "Technology",
    description:
      "CO₂ capture and utilisation research — transforming carbon from a climate liability into a valuable industrial resource.",
    href: "/technology",
  },
  {
    title: "Battery",
    description:
      "Expert guidance on Battery Energy Storage Systems (BESS) for residential, commercial, and industrial use.",
    href: "/battery",
  },
  {
    title: "Services",
    description:
      "End-to-end property development, strategic consultation, and professional project management.",
    href: "/services",
  },
];

const Home: React.FC = () => {
  return (
    <>
      {/* ── Hero ── */}
      <Box
        sx={{
          bgcolor: "#fff",
          py: { xs: 8, md: 12 },
          px: 2,
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h3"
            component="h1"
            sx={{ fontWeight: 800, mb: 2, letterSpacing: "-0.5px", fontFamily: "Roboto, sans-serif", color: "#1a1a2e" }}
          >
            DH Technologies Pty Ltd
          </Typography>

        </Container>
      </Box>

      {/* ── What We Do ── */}
      <Box sx={{ bgcolor: "#f7f9fc", py: { xs: 6, md: 8 }, px: 2 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{ fontWeight: 700, mb: 5, fontFamily: "Roboto, sans-serif" }}
          >
            What We Do
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "center",
            }}
          >
            {pillars.map((p) => (
              <Box
                key={p.title}
                component="a"
                href={p.href}
                sx={{
                  display: "block",
                  px: 3,
                  py: 2,
                  borderRadius: "8px",
                  border: "1px solid #e0e4ed",
                  bgcolor: "#fff",
                  textDecoration: "none",
                  color: "inherit",
                  width: { xs: "100%", sm: "calc(50% - 8px)", md: "calc(33.333% - 11px)" },
                  boxSizing: "border-box",
                  transition: "box-shadow 0.2s",
                  "&:hover": {
                    boxShadow: "0 4px 16px rgba(13,27,62,0.1)",
                  },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, fontFamily: "Roboto, sans-serif", mb: 0.5 }}
                >
                  {p.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#666", lineHeight: 1.6, fontFamily: "Roboto, sans-serif" }}
                >
                  {p.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* ── Contact ── */}
      <Contact />
    </>
  );
};

export default Home;
